import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_pagination_button = _resolveComponent("o-pagination-button")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(_ctx.rootClasses)
  }, [
    (_ctx.hasPreviousSlot)
      ? _renderSlot(_ctx.$slots, "previous", {
          key: 0,
          linkClass: _ctx.linkClasses,
          linkCurrentClass: _ctx.linkCurrentClasses,
          page: _ctx.getPage(_ctx.current - 1, {
                class: _ctx.prevBtnClasses,
                'aria-label': _ctx.ariaPreviousLabel
        })
        }, () => [
          _createVNode(_component_o_icon, {
            icon: _ctx.iconPrev,
            pack: _ctx.iconPack,
            both: "",
            "aria-hidden": "true"
          }, null, 8, ["icon", "pack"])
        ])
      : (_openBlock(), _createBlock(_component_o_pagination_button, {
          key: 1,
          class: _normalizeClass(_ctx.prevBtnClasses),
          linkClass: _ctx.linkClasses,
          linkCurrentClass: _ctx.linkCurrentClasses,
          page: _ctx.getPage(_ctx.current - 1)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_o_icon, {
              icon: _ctx.iconPrev,
              pack: _ctx.iconPack,
              both: "",
              "aria-hidden": "true"
            }, null, 8, ["icon", "pack"])
          ]),
          _: 1
        }, 8, ["class", "linkClass", "linkCurrentClass", "page"])),
    (_ctx.hasNextSlot)
      ? _renderSlot(_ctx.$slots, "next", {
          key: 2,
          linkClass: _ctx.linkClasses,
          linkCurrentClass: _ctx.linkCurrentClasses,
          page: _ctx.getPage(_ctx.current + 1, {
                class: _ctx.nextBtnClasses,
                'aria-label': _ctx.ariaNextLabel,
        })
        }, () => [
          _createVNode(_component_o_icon, {
            icon: _ctx.iconNext,
            pack: _ctx.iconPack,
            both: "",
            "aria-hidden": "true"
          }, null, 8, ["icon", "pack"])
        ])
      : (_openBlock(), _createBlock(_component_o_pagination_button, {
          key: 3,
          class: _normalizeClass(_ctx.nextBtnClasses),
          linkClass: _ctx.linkClasses,
          linkCurrentClass: _ctx.linkCurrentClasses,
          page: _ctx.getPage(_ctx.current + 1)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_o_icon, {
              icon: _ctx.iconNext,
              pack: _ctx.iconPack,
              both: "",
              "aria-hidden": "true"
            }, null, 8, ["icon", "pack"])
          ]),
          _: 1
        }, 8, ["class", "linkClass", "linkCurrentClass", "page"])),
    (_ctx.simple)
      ? (_openBlock(), _createElementBlock("small", {
          key: 4,
          class: _normalizeClass(_ctx.infoClasses)
        }, [
          (_ctx.perPage == 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.firstItem) + " / " + _toDisplayString(_ctx.total), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.firstItem) + "-" + _toDisplayString(Math.min(_ctx.current * _ctx.perPage, _ctx.total)) + " / " + _toDisplayString(_ctx.total), 1)
              ], 64))
        ], 2))
      : (_openBlock(), _createElementBlock("ul", {
          key: 5,
          class: _normalizeClass(_ctx.listClasses)
        }, [
          (_ctx.hasFirst)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: _normalizeClass(_ctx.listItemClass)
              }, [
                (_ctx.hasDefaultSlot)
                  ? _renderSlot(_ctx.$slots, "default", {
                      key: 0,
                      page: _ctx.getPage(1),
                      linkClass: _ctx.linkClasses,
                      linkCurrentClass: _ctx.linkCurrentClasses
                    })
                  : (_openBlock(), _createBlock(_component_o_pagination_button, {
                      key: 1,
                      linkClass: _ctx.linkClasses,
                      linkCurrentClass: _ctx.linkCurrentClasses,
                      page: _ctx.getPage(1)
                    }, null, 8, ["linkClass", "linkCurrentClass", "page"]))
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.hasFirstEllipsis)
            ? (_openBlock(), _createElementBlock("li", {
                key: 1,
                class: _normalizeClass(_ctx.listItemClass)
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.ellipsisClasses)
                }, "…", 2)
              ], 2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagesInRange, (page) => {
            return (_openBlock(), _createElementBlock("li", {
              key: page.number,
              class: _normalizeClass(_ctx.listItemClass)
            }, [
              (_ctx.hasDefaultSlot)
                ? _renderSlot(_ctx.$slots, "default", {
                    key: 0,
                    page: page,
                    linkClass: _ctx.linkClasses,
                    linkCurrentClass: _ctx.linkCurrentClasses
                  })
                : (_openBlock(), _createBlock(_component_o_pagination_button, {
                    key: 1,
                    linkClass: _ctx.linkClasses,
                    linkCurrentClass: _ctx.linkCurrentClasses,
                    page: page
                  }, null, 8, ["linkClass", "linkCurrentClass", "page"]))
            ], 2))
          }), 128)),
          (_ctx.hasLastEllipsis)
            ? (_openBlock(), _createElementBlock("li", {
                key: 2,
                class: _normalizeClass(_ctx.listItemClass)
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.ellipsisClasses)
                }, "…", 2)
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.hasLast)
            ? (_openBlock(), _createElementBlock("li", {
                key: 3,
                class: _normalizeClass(_ctx.listItemClass)
              }, [
                (_ctx.hasDefaultSlot)
                  ? _renderSlot(_ctx.$slots, "default", {
                      key: 0,
                      page: _ctx.getPage(_ctx.pageCount),
                      linkClass: _ctx.linkClasses,
                      linkCurrentClass: _ctx.linkCurrentClasses
                    })
                  : (_openBlock(), _createBlock(_component_o_pagination_button, {
                      key: 1,
                      linkClass: _ctx.linkClasses,
                      linkCurrentClass: _ctx.linkCurrentClasses,
                      page: _ctx.getPage(_ctx.pageCount)
                    }, null, 8, ["linkClass", "linkCurrentClass", "page"]))
              ], 2))
            : _createCommentVNode("", true)
        ], 2))
  ], 2))
}